import { FC } from 'react';
import { isEmpty } from 'lodash';
import { useQuery } from '@apollo/client';
import cx from 'classnames';
import Typo from '../Typography/Typo';
import { SearchHistoryHeader } from './SearchHistoryHeader';
import { SearchHistoryList } from './SearchHistoryList';
import { useReactiveAuthenticatedUser } from '../Auth/hooks/useAuthenticatedUser';
import { getSearchHistoryByUserId } from './queries/getSearchHistoryByUserId';

type TSearchFormHistoryProps = {
  onItemClick: () => void;
  className?: string;
  searchResultPageGetter: (term: string) => string;
};

export const SearchHistory: FC<TSearchFormHistoryProps> = ({ onItemClick, className, searchResultPageGetter }) => {
  const { isAuthenticated, data } = useReactiveAuthenticatedUser();
  const userId = data?.user?.id;

  const {
    data: searchHistories,
    called: isCalled,
    loading: isLoading,
  } = useQuery(getSearchHistoryByUserId, {
    variables: {
      userId,
      take: 5,
    },
    skip: !userId,
  });

  if ((!isCalled && !isLoading) || isEmpty(searchHistories?.searchHistories) || !isAuthenticated) {
    return (
      <div className={cx('flex h-[250px] mt-6 justify-center', className)}>
        <Typo variant="small-p" className="!text-xs text-t2-neutral-grey06">
          No recent search history
        </Typo>
      </div>
    );
  }

  return (
    <div className={cx('mt-6 h-[250px]', className)}>
      <SearchHistoryHeader userId={data?.user?.id} />
      <SearchHistoryList
        searchHistories={searchHistories?.searchHistories}
        onItemClick={onItemClick}
        searchResultPageGetter={searchResultPageGetter}
      />
    </div>
  );
};
